// Utilities
module.exports = function () {
    const ValidationErrors = require('../templates/forms/form-error-messages.handlebars');
    const $ = window.$;

    var U = {};

    var GUIDCounter = function () {
        var count = 234;
        var next = function () {
            count += 1;
            return count;
        }
        return next;
    };
    U.NextGUID = GUIDCounter();

    U.getCookie = function (name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) {
            return parts.pop().split(";").shift();
        }
    };

    U.setCookie = function (cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires + ";path=/";
    };

    U.PadWithZeros = function (num) {
        var s = num + "";
        while (s.length < 2) {
            s = "0" + s;
        }
        return s;
    };

    U.GetDurationString = function (durationInMinutes) {
        var days = Math.floor((durationInMinutes / 60) / 24);
        var hoursActual = (durationInMinutes - (days * 60 * 24)) / 60
        var hours = Math.floor(hoursActual);
        var minutes = Math.floor(durationInMinutes - ((days * 60 * 24) + (hours * 60)));
        return s = days + "d " + hours + "h " + minutes + "m ";
    };

    // Data Overrides
    Date.prototype.toNiceString = function () {
        var dat = new Date(this.valueOf());
        var hourNum = dat.getHours();
        var amPm = hourNum >= 12 ? " pm" : " am";
        var hours = amPm === " am" ? hourNum : hourNum - 12;
        var hours = hours === 0 ? 12 : hours;
        var s;
        if (dat > (new Date("01/01/2098"))
             || dat.getTime() == (new Date("01/01/2001 00:00:00")).getTime()
             || dat.getTime() == (new Date("01/01/1901 00:00:00")).getTime()) {
            s = "n/a";
        } else {
            s = U.PadWithZeros(dat.getFullYear()) + "-"
                + U.PadWithZeros(dat.getMonth() + 1)
                + "-" + U.PadWithZeros(dat.getDate())
                + " " + U.PadWithZeros(hours)
                + ":" + U.PadWithZeros(dat.getMinutes())
                + amPm;
        }
        return s;
    };

    Date.prototype.toNiceDateString = function () {
        var dat = new Date(this.valueOf());
        var hourNum = dat.getHours();
        var amPm = hourNum >= 12 ? " pm" : " am";
        var hours = amPm === " am" ? hourNum : hourNum - 12;
        var hours = hours === 0 ? 12 : hours;
        var s;
        if (dat > (new Date("01/01/2098"))
            || dat.getTime() == (new Date("01/01/2001 00:00:00")).getTime()
            || dat.getTime() == (new Date("01/01/1901 00:00:00")).getTime()) {
            s = "n/a";
        } else {
            s = U.PadWithZeros(dat.getFullYear()) + "-"
                + U.PadWithZeros(dat.getMonth() + 1)
                + "-" + U.PadWithZeros(dat.getDate());
        }
        return s;
    };

    Date.prototype.toNiceTimeString = function () {
        var dat = new Date(this.valueOf());
        var hourNum = dat.getHours();
        var amPm = hourNum >= 12 ? " pm" : " am";
        var hours = amPm === " am" ? hourNum : hourNum - 12;
        var hours = hours === 0 ? 12 : hours;
        var s;
        if (dat > (new Date("01/01/2098"))
             || dat.getTime() == (new Date("01/01/2001 00:00:00")).getTime()
             || dat.getTime() == (new Date("01/01/1901 00:00:00")).getTime()) {
            s = "n/a";
        } else {
            s = U.PadWithZeros(hours)
                + ":" + U.PadWithZeros(dat.getMinutes())
                + ":" + U.PadWithZeros(dat.getSeconds())
                + amPm;
        }
        return s;
    };

    U.GetJqueryFormData = function (jqueryForm) {
        var serialized = jqueryForm.serializeArray().reduce(function (obj, item) {
            obj[item.name] = item.value;
            return obj;
        }, {});
        jqueryForm.find('select[multiple="multiple"]').each(function () {
            var name = $(this).attr('name');
            serialized[name] = U.GetSelectData($(this));
        })

        return serialized;
    };

    U.GetJqueryFormDataFlat = function (jqueryForm) {
        var serialized = jqueryForm.serializeArray().reduce(function (obj, item) {
            obj[item.name] = item.value;
            return obj;
        }, {});
        jqueryForm.find('select[multiple="multiple"]').each(function () {
            var name = $(this).attr('name');
            serialized[name] = U.GetSelectDataFlat($(this));
        })

        return serialized;
    };

    U.GetSelected = function (container, className) {
        var $select = container.closest('form').find('select.' + className);
        return U.GetSelectData($select);
    }

    U.GetSelectData = function ($select) {
        var ar = [];

        $select.find('option:selected').each(function () {
            ar.push({ ID: this.value, Name: this.innerHTML });
        });

        return ar;
    }

    U.GetSelectDataFlat = function ($select) {
        var ar = [];

        $select.find('option:selected').each(function () {
            ar.push(this.value);
        });

        return ar;
    }

    U.GetFormData = function (container) {
        var form = container.closest('form');
        return U.GetJqueryFormData(form);
    };

    U.GetFormDataFlat = function (container) {
        var form = container.closest('form');
        return U.GetJqueryFormDataFlat(form);
    };

    U.ClearForm = function (jqueryEl) {
        jqueryEl.closest('form').find("input[type=text], textarea").val("");
    };

    U.AddValidationErrors = function ($form, validation) {
        for (var i = 0; i < validation.Errors.length; i++) {
            var error = validation.Errors[i];
            var $input = $form.find('input[name="' + error + '"]');
            $input.addClass('input-error');
        }
        var html = ValidationErrors(validation);
        $form.find('.validation-errors').html(html);
    };

    U.GetTableColumnCount = function($tr) {
        var count = 0;
        $tr.children('td').each(function () {
            if ($(this).attr('colspan')) {
                count += +$(this).attr('colspan');
            } else {
                count++;
            }
        });
        return count;
    }

    U.GetTableRowCount = function ($table) {
        var count = 0;
        $table.children('tr').each(function () {
            count++;
        });
        return count;
    }

    U.RemoveSelf = function (ownObjects, objects, ownObjectIDName, objectIDName) {
        // Create dict
        var ownDict = {};
        if (ownObjects) {
            for (var i = 0; i < ownObjects.length; i++) {
                var obj = ownObjects[i];
                if (obj) {
                    ownDict[obj[ownObjectIDName]] = true;
                }
            }
        }

        // Remove self
        if (objects) {
            for (var i = 0; i < objects.length; i++) {
                var obj = objects[i];
                if (obj) {
                    if (ownDict[obj[objectIDName]]) {
                        objects.splice(i, 1);
                        i--;
                    }
                }
            }
        }
    }

    function setupClickToggle($slideable, len) {
        var $body = $('body');

        var checkClick = function (e) {
            $slideable.data('shown', false);
            $slideable.slideUp(len);
            $body.off('click', checkClick);
        }

        $body.on('click', checkClick);
    }

    function setupOuterClickToggle($container, $inner, speed, guid, $closeButton) {
        var $body = $('body');

        var close = function () {
            $container.data('shown', false);
            $container.fadeOut(speed);
            setEvents('off');
        }

        var checkClick = function (e) {
            if (!$(e.target).closest('.' + guid).length) {
                close();
            }
        }

        function onKeyDown(e) {
            if (e.which === 27) {
                close();
            }
        }

        function setEvents(onOrOff) {
            $body[onOrOff]('click', checkClick);
            $body[onOrOff]('keydown', onKeyDown);
            $closeButton[onOrOff]('click', close);
        }

        setEvents('on');
    }

    U.OpenModalMenu = function ($slideable, len) {
        if (!$slideable.data('shown')) {
            $slideable.data('shown', true);
            $slideable.slideDown(len);
            setupClickToggle($slideable, len);
        } else {
            $slideable.data('shown', false);
            $slideable.slideUp(len);
        }
    }

    U.OpenModalInfo = function ($container, $info, speed, $closeButton) {
        if (!$container.data('shown')) {
            var guid = 'INFO-GUID-' + U.NextGUID();
            $info.addClass(guid);
            $container.data('shown', true);
            $container.fadeIn(speed);
            setupOuterClickToggle($container, $info, speed, guid, $closeButton);
        } else {
            $container.data('shown', false);
            $container.fadeOut(speed);
        }
    }

    return U;
}();


// WEBPACK FOOTER //
// ./Scripts/lib/utilities.js